import { useState } from 'react'
import { downloadBlob } from '@pelvia/shared/api'

export type ConsultNoteFormat = 'pdf' | 'text' | 'fhir'

/**
 * Download the signed consult note (web). Fetches the file with the app's auth
 * (the shared `downloadBlob` reads it as a Blob so binary isn't corrupted), then
 * saves it via a transient object URL + anchor click. Gated server-side to a
 * paid + signed-off order, so the button only no-ops on a stale UI.
 */
export function useDownloadConsultNote() {
  const [downloading, setDownloading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function download(format: ConsultNoteFormat = 'pdf') {
    setError(null)
    setDownloading(true)
    try {
      const { blob, filename } = await downloadBlob(`/api/patient/report?format=${format}`)
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = filename
      document.body.appendChild(a)
      a.click()
      a.remove()
      // Revoke after the click has had a chance to start the save.
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    } catch {
      setError("Couldn't download your note right now. Please try again.")
    } finally {
      setDownloading(false)
    }
  }

  return { download, downloading, error }
}
